import React, { useState, useCallback, useMemo, useEffect } from 'react'
import 'react-lazy-load-image-component/src/effects/blur.css'
import '../../components/CategoryGrid.css'

import { imageBaseURL } from '../../services/defaultProps'
import LoadingCloset from '../../components/LoadingCloset'
import { useLocation, useHistory } from 'react-router-dom'
import sendMessageWPP from '../../services/sendMessageWPP'
import API from '../../services/Api'
import EmptyCloset from '../../components/EmptyCloset'
import Header from '../../components/Header'
import { FiArrowLeft } from 'react-icons/fi'
import ImageGridPhotos from '../../components/ImageGridPhotos'
import useLanguage from '../../hooks/useLanguage'
import '../../styles/containers/ImageGrid.css'

const ImageGrid = props => {
  const location = useLocation()
  const history = useHistory()

  const photos = useMemo(() => location.state && location.state.photos, [location.state])

  const language = useLanguage()
  const [sendingMessage, setSendingMessage] = useState(false)

  const renderPhotosGrid = useCallback(() => {
    const items = photos.map((item, index) => ({
      id: item.id,
      photo: imageBaseURL + item.image,
      onClick: () => {
        history.push('/closet/carousel', { photos, initialPhoto: index, title: location.state.title })
      }
    })
    )

    return <ImageGridPhotos photos={items} />
  }, [photos])

  const requestService = useCallback(async () => {
    const reqServiceMessage = (consultant) => ([
      `Olá ${consultant}. Estou com muita vontade de montar looks para poder colocar no MOSTY, pode me explicar como funciona esse serviço?`,
      `Hello ${consultant}. I really want to mount looks to be able to put on MOSTY, can you explain to me how this service works?`,
      `Hola, ${consultant}. Realmente quiero montar miradas para poder ponerme MOSTY, ¿me pueden explicar cómo funciona este servicio?`
    ])

    setSendingMessage(true)

    try {
      const { consultantName, consultantPhone } = await API.getUser(props.token)

      sendMessageWPP(
        consultantPhone,
        reqServiceMessage(consultantName)[language]
      )
    } catch (err) {
      console.error(err)
    }

    setSendingMessage(false)
  }, [props.token, language])

  const renderPhotos = useCallback(() => {
    if (photos.length === 0) { return <EmptyCloset language={language} onLinkClick={requestService} /> } else if (sendingMessage) { return <LoadingCloset /> } else { return renderPhotosGrid() }
  }, [])

  useEffect(() => {
    if (!photos) {
      history.replace('/closet')
    }

    setTimeout(() => window.scrollTo(0, 0), 1)
  }, [])

  return (
    <div className='imagegrid-screen-container'>
      <Header language={language} />
      <div className='imagegrid-screen-title'>
        <FiArrowLeft onClick={() => history.goBack()}
          size={24} color='var(--primary)' className='imagegrid-screen-goback' />
        <p>{location.state.title}</p>
      </div>
      {renderPhotos()}
    </div>
  )
}

export default ImageGrid



// WEBPACK FOOTER //
// ./src/containers/Closet/ImageGrid.js